module.exports = __webpack_public_path__ + "img/brushcopy1.113f07b7.png";